import { DIMENSION_CATEGORY_KEYS } from '@src/utils/dimension/dimensionCategories';
import { metricKeys } from '@pulse/metrics';

export const USER_ID_FIELD = 'app_user_id';
export const CLIENT_ID_FIELD = 'client_id';
export const DEVICE_NAME_FIELD = 'device_name';

export const supportedDimensionCategories = [
  DIMENSION_CATEGORY_KEYS.eco.content,
  DIMENSION_CATEGORY_KEYS.eco.device,
  DIMENSION_CATEGORY_KEYS.eco.geo,
];
export const excludeMetricCategories = ['ECO_ENGAGEMENT'];
export const excludedMetrics = [
  metricKeys.AppSessions,
  metricKeys.AppSubscribers,
  metricKeys.AppUniqueDevices,
];
export const defaultMetrics = [
  metricKeys.AppErrors,
  metricKeys.AppCrashSessions,
  metricKeys.FailedNetworkRequest,
];

export const FLOW_START_TIMESTAMP_FIELD = 'flow_start_timestamp';
export const FLOW_END_TIMESTAMP_FIELD = 'flow_end_timestamp';

export const ALL_FLOWS_IDENTIFIER = 'all_flows';
